@if (type === 'text' || type === 'password' || type === 'email') {
  <label>
    <ng-content></ng-content>
    {{ label }}
    <div class="input-group">
      <input
        class="form-control"
        [(ngModel)]="value"
        (keyup)="onChange(value); onTouch()"
        [class.error]="hasError"
        [placeholder]="placeholder"
        [type]="currentType"
        (change)="onTouch()"
        [id]="name"
        [attr.name]="name"
        >
      @if (type === 'password') {
        <a (click)="toggleType()"
          (keyup.enter)="toggleType()"
          onkeydown=""
          tabindex="0">
          <app-icon [icon]="currentType === 'password' ? 'eye-slash' : 'eye'"></app-icon>
        </a>
      }
    </div>
  </label>
}

@if (type === 'checkbox' || type === 'radio') {
  <label>
    <input
      class="form-control"
      [type]="type"
      [name]="name"
      [value]="value"
      [checked]="control.value === value"
      [class.error]="hasError"
      [id]="name"
      (change)="handleChange($event)"
      >
    @if (type === 'checkbox') {
      <span class="checked-icon">√</span>
    }
    @if (type === 'radio') {
      <span class="checked-icon"><span class="orb"></span></span>
    }
    {{ label }}
  </label>
}

@if (type === 'textarea') {
  <label>
    {{ label }}
    <textarea class="input" [placeholder]="placeholder" [(ngModel)]="this.value"
    (keyup)="this.onChange(this.value)" [id]="this.name"></textarea>
  </label>
}
